module.exports = __webpack_public_path__ + "static/media/roar0.21a95e3d.mp3";